import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { TypeUnsafeTranslation } from '~src/commonInfra/services/IReactTranslateService';
import { clearFilterButton } from '~src/spacesPlatform/components/filterPanel/FilterPanelStyles';
import { ContentFilterKeyName } from '~src/spacesPlatform/models/ContentFilters';

export interface ClearFilterButtonProps {
  readonly filterName: ContentFilterKeyName;
  readonly clearFilter: () => void;
  readonly getElementToRefocus: () => (HTMLElement | null);
}

export function ClearFilterButton(props: ClearFilterButtonProps) {
  return <ButtonWidget
    buttonType={ButtonType.LowEmphasis}
    children={Messages.clear()}
    className={clearFilterButton}
    aria-label={Messages.clearFilterAriaLabel({ FILTER_NAME: TypeUnsafeTranslation.translate(props.filterName) })}
    style={{height: 20, fontWeight: 'normal', minWidth: 0}}
    onClick={() => {
      props.clearFilter();
      props.getElementToRefocus()?.focus();
    }}
    testId={'clear-filter-' + props.filterName}
  />;
}
